import Vue from 'vue';
class BaseModel extends Vue {
}
export default BaseModel;



// WEBPACK FOOTER //
// ./src/model/modules/base.js